import { render, staticRenderFns } from "./addOrEditImgTextDialog.vue?vue&type=template&id=39bbee2e"
import script from "./addOrEditImgTextDialog.vue?vue&type=script&lang=js"
export * from "./addOrEditImgTextDialog.vue?vue&type=script&lang=js"
import style0 from "./addOrEditImgTextDialog.vue?vue&type=style&index=0&id=39bbee2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports